export default (initialTab = 'main') => ({
    activeTab: initialTab,

    setActiveTab(tab) {
        this.activeTab = tab;
    },
    
    isActiveTab(tab) {
        return this.activeTab === tab;
    }
});